import React from 'react'
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Typography } from '@mui/material'

import { MattersMostStepProps } from '../types'

const MattersMostStep: React.FC<MattersMostStepProps> = ({ value, maxSelections, onChange, error }) => {
  const options = [
    'Price',
    'Distance to campus',
    'Furnished units',
    'Roommates / Community',
    'Amenities (gym, study rooms, etc.)',
    'Lease flexibility',
  ]

  const handleToggle = (opt: string) => {
    if (value.includes(opt)) {
      onChange(value.filter(v => v !== opt))
    } else if (value.length < maxSelections) {
      onChange([...value, opt])
    }
  }

  return (
    <Box className="flex flex-col gap-6">
      <Typography variant="h5" className="font-bold text-gray-900">
        What matters most to you when choosing housing? (Pick up to {maxSelections})
      </Typography>

      <FormControl error={error}>
        <FormGroup className="flex flex-col gap-2">
          {options.map(opt => (
            <FormControlLabel
              key={opt}
              value={opt}
              control={
                <Checkbox
                  checked={value.includes(opt)}
                  onChange={() => handleToggle(opt)}
                  disabled={!value.includes(opt) && value.length >= maxSelections}
                />
              }
              label={opt}
              className="text-base"
            />
          ))}
        </FormGroup>
        <FormHelperText error={error}>
          {error
            ? `Please select no more than ${maxSelections} options`
            : `Select up to ${maxSelections} options (${value.length}/${maxSelections} selected)`}
        </FormHelperText>
      </FormControl>
    </Box>
  )
}

export default MattersMostStep
